<template>
	<div>

		<div v-if="loading">
			Loading ...
		</div>
		<template v-else>

			<button v-on:click="t">x</button>

			<div v-for="(pin, resource) in getPins" class="pin" v-bind:class="{
				active: activeUrl == getPinUrl(pin),
			}">
				<div class="flex">
					<template v-if="resource.split(':')[0] == 'order'">
						<h3>
							<OrderLink :id="resource.split(':')[1]" />
						</h3>
					</template>
					<template v-else>
						<h3><a :href="getPinUrl(pin)">{{ getPinName(pin) }}</a></h3>
					</template>
				</div>

				<div class="events">
					<div v-for="event in pin.events" class="event">
						<div class="messages">
							<div class="flex full-width">
								<div class="flex-grow">
									{{ event.message }}
									<div class="note">
										<!-- <strong>{{ event.created_at.substr(0, 10) }}</strong>: {{ event.event }} -->
										<div class="">
											<button :disabled="saving" class="smaller" v-on:click="unpin(event.id, false)">
												Unpin
											</button>
											<button :disabled="saving" class="smaller gray small-margin-left" v-on:click="unpin(event.id, true)">
												Unpin forever
											</button>
										</div>
									</div>
								</div>
								<!-- <UserSelector v-model="event.assigned_to" v-on:change="updatePinAssignment(event)" /> -->
							</div>
						</div>
					</div>
				</div>
			</div>

		</template>

	</div>
</template>

<style lang="less" scoped>
	.pin {
		margin-bottom: 30px;
		.events {
			.event {
				position: relative;
				margin-bottom: 15px;
				border: 1px solid #ddd;
				transition: 200ms;
				padding: 15px;
				font-size: 13px;
				.note {
					border: 1px solid #ccc;
					display: none;
					position: absolute;
					background: #fff;
					z-index: 100;
					padding: 15px;
					top: 100%;
					left: -1px;
					right: -1px;
				}
				&:hover {
					border-color: #ccc;
					box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
					.note {
						display: block;
					}
				}
			}
		}
		&.active {
			border: 2px solid #ccc;
			background: #f6f6f6;
			padding: 15px;
		}
	}
</style>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'isSidebarOpen',
      'getStylist',
      'getSidebarPins'
    ]),
    activeUrl () {
      return '/#' + this.$route.path
    },
    getPins (tab) {
      var pins = {}

      for (var p in this.getSidebarPins) {
        var pin = this.getSidebarPins[p]

        for (var event of pin.events) {
          if (event.assigned_to == this.getStylist.id) {
            pins[p] = pin
          }
        }
      }

      return pins
    }
  },
  data: () => ({
    loading: false,
    saving: false,
    pins: []
  }),
  watch: {
    isSidebarOpen () {
      if (this.isSidebarOpen) {
        this.load()
      }
    }
  },
  methods: {
    t () {
      console.log(this.getPins)
    },
    load () {
      Vue.api.get('/pin/sorted', {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => this.parsePins(data)
      })
    },
    parsePins (data) {
      this.$store.commit('setSidebarPins', data.pins)
    },
    getPinName (pin) {
      switch (pin.resource) {
        case 'order':
          return 'Order ' + pin.resource_id
        case 'product':
          return 'Product ' + pin.resource_id
        case 'user':
          return 'Customer ' + pin.resource_id
        case 'email':
          return 'Email ' + pin.resource_id
        case 'subscription':
          return 'Subscription ' + pin.resource_id
        case 'worker':
          return 'Worker ' + pin.resource_id
        case 'klaviyo':
          return 'Klaviyo'
        case 'tablestatus':
          return 'Worker table'
        case 'streamline':
          return 'Streamline API'
      }
    },
    getPinUrl (pin) {
      switch (pin.resource) {
        case 'klaviyo':
          return ''
        case 'email':
          return '/#/email/' + pin.resource_id
        case 'user':
          return '/#/customer/' + pin.resource_id
        case 'subscription':
          return '/#/subscription/' + pin.resource_id
        default:
          return '/#/' + pin.resource + '/' + pin.resource_id
      }
    },
    unpin (id, forever) {
      var pins = this.getSidebarPins

      for (var p in pins) {
        for (var e in pins[p].events) {
          if (pins[p].events[e].id == id) {
            Vue.delete(pins[p].events, e)
          }
        }
      }

      this.$store.commit('setSidebarPins', pins)

      Vue.api.delete('/pin/' + id, {
        forever: forever
      }, {
        // callback: () => this.load(),
      })
    }
  },
  created () {
    if (this.isSidebarOpen) {
      this.load()
    }
  }
}
</script>
